var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:#99D1A4;}\r\n\t.st2{fill:#FDD106;}\r\n\t.st3{fill:#3B54A4;}\r\n\t.st4{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#FFFFFF;stroke:#263238;stroke-width:0.7043;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:#263238;}\r\n\t.st8{fill:#D8D8D7;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{fill:#231F20;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st10{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st11{fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st12{fill:#D8D8D7;stroke:#263238;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#808080;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st14{fill:#263238;stroke:#263238;stroke-miterlimit:10;}\r\n\t.st15{fill:#FFFFFF;stroke:#263238;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.08,23.93c0,0-26.75-9.52-53.02,5.63s-39.52,45.22-50.9,69.3s-4.83,48.58,15.22,59.76s33.68-5.3,61.8-6.1 s35.68,3.22,59.03-12.67s27.56-53.41,9.15-81.18S132.08,23.93,132.08,23.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.67,22.22c0,0-43.6-19.96-69.87-4.82S39.55,74.78,28.17,98.86s-4.83,48.58,15.22,59.76 s33.68-5.3,61.8-6.1s35.68,3.22,59.03-12.67s27.56-53.41,9.15-81.18S136.67,22.22,136.67,22.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.53,147.68c-0.04,0,0.65-2.21,0.71-2.34c0.69-1.55,2.94-4.15,4.82-3.95c1.23,0.16,2.1,1.29,1.93,2.52 c-0.01,0.08-0.03,0.16-0.04,0.24c-0.27,1.32-1.58,2.32-2.73,2.87C155.87,147.66,152.53,147.68,152.53,147.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.62,161.8c-1.47-0.21-4.27-2.03-4.27-2.03c0,0,1.76-1.47,1.88-1.56c1.43-0.92,4.73-1.84,6.2-0.64 c0.94,0.82,1.03,2.24,0.22,3.18c-0.05,0.06-0.11,0.12-0.17,0.17C136.52,161.86,134.88,161.98,133.62,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.18,147.68c-0.04,0,0.65-2.21,0.71-2.34c0.69-1.55,2.94-4.15,4.82-3.95c1.23,0.16,2.1,1.29,1.93,2.52 c-0.01,0.08-0.03,0.16-0.04,0.24c-0.27,1.32-1.58,2.32-2.73,2.87C109.52,147.66,106.18,147.68,106.18,147.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.36,33.75h68.02c1.56,0,2.82,1.26,2.82,2.82v133.5c0,1.56-1.26,2.82-2.82,2.82H73.36 c-1.56,0-2.82-1.26-2.82-2.82V36.57C70.54,35.01,71.8,33.75,73.36,33.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.82,
    y: 49.02,
    className: "st4",
    width: 67.12,
    height: 108.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.67,41.42h-14.59c-0.55,0-0.99-0.44-0.99-0.99l0,0c0-0.55,0.44-0.99,0.99-1c0,0,0,0,0,0h14.59 c0.55,0,0.99,0.44,0.99,0.99c0,0,0,0,0,0l0,0C115.66,40.98,115.22,41.42,114.67,41.42L114.67,41.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.35,163.74c0-2.2-1.78-3.98-3.98-3.98c-2.2,0-3.98,1.78-3.98,3.98c0,2.2,1.78,3.98,3.98,3.98 C109.57,167.73,111.35,165.95,111.35,163.74C111.35,163.75,111.35,163.75,111.35,163.74z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.36,
    y: 161.72,
    className: "st7",
    width: 4.04,
    height: 4.04
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.92,116.44l-0.43,3.31c0,0-1.8,12.3-0.55,18.65s3.59,12.85,3.73,14.37c0.14,1.52-0.69,7.46,0.28,12.3 s2.76,14.37,2.76,14.37l-1.52,3.59c0,0-3.18,2.07-3.59,2.76c-0.21,0.27-0.16,0.66,0.11,0.87c0.05,0.04,0.11,0.07,0.17,0.09h9.93 c0.3-0.74,0.45-1.55,0.42-2.35v-9.67c0-0.97,0.55-17.41,1.1-20.31c0.55-2.9,1.1-24.87,1.1-24.87h0.56c0,0,2.63,21.83,3.31,24.18 c0.68,2.35,3.59,12.43,4.41,14.51s1.8,9.25,2.35,11.05c0.53,1.63,0.94,3.29,1.24,4.97c0.14,0.85,0.37,1.68,0.69,2.49h7.49 c0,0,0.14-1.24-0.42-2.07s-4.14-4.41-4.7-7.05c-0.56-2.63,0.83-14.79,0.7-19.07s-1.38-4.84-1.38-8.57s1.38-15.06,1.38-20.45 c0-5.39-0.74-10.35-2.09-13.19l-1.92-1.87h-23.77L145.92,116.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.48,180.11v0.02c0,0-1.93-1.24-2.63-0.28c-0.69,0.97-0.69,1.52-0.69,1.52h-1.47 c0.27,0.95,0.49,1.92,0.64,2.9c0.14,0.85,0.37,1.68,0.69,2.49h7.45c0,0,0.14-1.24-0.42-2.07 C178.66,184.1,176.76,182.13,175.48,180.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M172.01,186.76h7.46c0.03-0.32,0.02-0.64-0.03-0.96h-7.77C171.84,186.35,172.01,186.76,172.01,186.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157.23,184.41v-2.35h-2.63c0,0,0.14-1.1-1.1-1.93c-1.24-0.83-2.49,1.1-2.49,1.1h-0.07l-0.76,1.8 c0,0-3.18,2.07-3.59,2.76c-0.21,0.27-0.16,0.66,0.11,0.87c0.05,0.04,0.11,0.07,0.17,0.09h9.93 C157.1,186.01,157.25,185.21,157.23,184.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.58,185.8c-0.21,0.27-0.15,0.66,0.12,0.87c0.05,0.04,0.1,0.07,0.16,0.09h9.93 c0.13-0.31,0.23-0.63,0.29-0.96H146.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.32,172.54c0.23-4.7,0.82-11.1,0.74-13.98c-0.14-4.29-1.38-4.84-1.38-8.57s1.38-15.05,1.38-20.44 c0-5.39-0.74-10.35-2.09-13.19l-1.92-1.87h-23.77l-1.36,1.94l-0.43,3.31c0,0-1.8,12.3-0.55,18.65c1.24,6.36,3.59,12.85,3.73,14.37 c0.14,1.52-0.69,7.46,0.28,12.3c0.43,2.12,1.01,5.15,1.53,7.88c2.23,0.5,4.51,0.71,6.79,0.61c0.12-4,0.6-16.62,1.07-19.13 c0.55-2.9,1.1-24.87,1.1-24.87h0.54c0,0,2.63,21.83,3.31,24.18c0.68,2.35,3.59,12.43,4.41,14.51c0.37,0.88,0.74,2.69,1.1,4.62 C170.64,173.19,172.53,173.08,174.32,172.54z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 161.65,
    y1: 128.31,
    x2: 169.11,
    y2: 122.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 150.73,
    y1: 122.92,
    x2: 154.6,
    y2: 126.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.96,55.97c0,0-3.17-1.88-3.1-0.86s1.44,1.73,1.44,1.73s-4.55-0.65-5.27-0.37 c-0.72,0.28,0.51,0.65,0.51,0.65s-5.63,4.33-7.57,7.28c-1.95,2.96-3.68,7.29-1.66,10.6c2.02,3.32,4.98,5.91,9.95,7.36 c4.98,1.44,9.88-0.07,13.2-1.44c3.32-1.37,6.62-5.27,6.06-10.17s-4.92-10.02-8.17-13.48c-3.25-3.46-5.26-2.94-5.26-2.45 C167.08,55.21,167.04,55.59,166.96,55.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M159.18,76.46l-0.74,5.55c0,0-5.27,1.73-7.21,2.52c-1.95,0.79-2.81,1.8-3.17,2.67s-5.52,12.87-5.74,14.01 c-0.22,1.14,0.14,1.66,1.73,2.38c1.59,0.72,6-1.95,6-1.95l0.58,2.02c0,0-2.89,4.9-3.39,6.49s-1.3,6.28-1.3,6.28 s5.48,2.74,14.14,2.53c8.66-0.21,12.91-2.6,12.91-2.6s-0.94-4.69-1.95-7.43s-1.88-3.82-1.88-4.9c0-1.08,3.17-6.71,3.17-6.71 l6.7,3.16c0,0-1.58-5.47-2.02-9.14c-0.43-3.68-1.18-4.28-2.63-5.58c-1.45-1.3-7.79-3.17-8-3.31c-0.22-0.14,0.29-6.2,0.29-6.2 S161.2,77.69,159.18,76.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M163.37,80.26c1.01-0.37,2.21-1.32,3.15-2.17c0.08-1.03,0.14-1.84,0.14-1.84s-5.46,1.45-7.48,0.22l-0.5,3.68 C159.8,81.15,161.63,80.92,163.37,80.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.01,108.94c-1.01-2.74-1.88-3.82-1.88-4.9c0-1.08,3.17-6.71,3.17-6.71l6.7,3.16c0,0-1.58-5.47-2.02-9.14 c-0.23-1.99-0.56-3.08-1.04-3.86c-10.28,1.31-21.7-1.04-26.26-2.14c-0.72,0.45-1.3,1.1-1.65,1.87 c-0.37,0.87-5.52,12.87-5.74,14.01c-0.22,1.14,0.14,1.66,1.73,2.38c1.59,0.72,6.01-1.95,6.01-1.95l0.58,2.02 c0,0-2.89,4.9-3.39,6.49s-1.3,6.28-1.3,6.28s5.48,2.74,14.14,2.53c8.66-0.21,12.91-2.6,12.91-2.6S172.02,111.68,171.01,108.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M150.95,99.67c0,0-1.43-3.01-1.04-4.57c0.39-1.57,0.65-1.96,0.65-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177,91.34c-0.23-1.99-0.56-3.08-1.04-3.86c-10.28,1.31-21.7-1.04-26.26-2.14c-0.72,0.45-1.3,1.1-1.65,1.87 c-0.13,0.31-0.85,1.99-1.74,4.1c4.05,1.1,19.54,4.94,31.22,3.14C177.31,93.37,177.12,92.29,177,91.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M160.59,63.05l9.2,5.93l-0.25,2.39c0,0,1.64-1.64,1.89,0.13c0.25,1.77-0.37,2.65-1.52,3.15 c-1.15,0.5-1.77,0.37-1.77,0.37s-2.77,3.02-4.78,3.78c-2.01,0.76-4.16,0.96-5.15-0.68c-0.99-1.64-2.41-4.61-2.03-6.38 c0.38-1.77,3.79-8.69,3.79-8.69H160.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.49,68.65c0,0.45-0.15,0.88-0.43,1.22c-0.43,0.43-1.44,1.01-1.44,1.44c0,0.43,0.94,1.3,1.8,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.9,73.49c0.88,0.6,2.04,0.57,2.89-0.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.37,69.73c0,0,1.59-0.58,2.45,0.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M158.46,69.01c0,0,1.3-0.58,1.95,0.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.26,66.56c0.49-0.6,1.29-0.83,2.02-0.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M164.09,66.7c0,0,2.02,0.07,2.45,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M145.63,98.84c0,0-2.24,0.86-2.94,2.24c-0.71,1.37-0.58,4.54,2.23,5.34c2.81,0.79,23.59-3.39,23.59-3.39 c0.51,0.78,1.06,1.52,1.66,2.24c0.51,0.5,1.81,1.52,1.88,1.95c0.07,0.43,0.22,3.17,0.79,3.31s0.37-1.3,0.37-1.3 s0.94-1.37,0.94-2.02c0-0.65,0.14-2.74,0-3.24s-3.53-3.46-4.26-3.68c-0.72-0.22-19.19-0.74-20.92-1.01 C147.24,98.99,146.2,98.76,145.63,98.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.22,80.46l-2.21-1.47c-0.39-0.26-0.5-0.79-0.24-1.18l4.45-6.7c0.26-0.39,0.79-0.5,1.18-0.24l2.21,1.47 c0.39,0.26,0.5,0.79,0.24,1.18l-4.45,6.7C167.13,80.61,166.61,80.72,166.22,80.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M170.64,79.11c0,0,0.46-1.17,0.91-2.01s0.46-1.24,0.13-1.24c-0.71,0.13-1.27,0.66-1.43,1.36 c-0.16,0.7-0.2,1.43-0.13,2.14L170.64,79.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M166.74,83.59c0,0,3.7-3.7,3.83-4.03c0.13-0.32,0-4.54-0.06-5.73c0-0.18-0.13-0.34-0.31-0.37l0,0 c-0.2-0.04-0.39,0.08-0.44,0.28c0,0.02-0.01,0.04-0.01,0.06l-0.29,3.42l-0.85-4.3c-0.03-0.18-0.19-0.31-0.37-0.31l0,0 c-0.2,0-0.37,0.16-0.37,0.37c0,0.01,0,0.02,0,0.03l0.24,4.78l-1.07-4.09c-0.06-0.21-0.27-0.34-0.48-0.28c0,0,0,0,0,0l0,0 c-0.19,0.05-0.31,0.23-0.29,0.43l0.48,4.41l-0.91,0.78v-1.56l-1.1-1.84c-0.08-0.14-0.26-0.19-0.4-0.12l0,0 c-0.15,0.07-0.21,0.25-0.14,0.4l0.74,1.61c0,0-1.43,5.85-1.5,6.04s0.26,1.24,0.46,1.63c0.19,0.39,8.9,18.84,9.42,19.55 s4.03,1.82,5.59,0.13c1.56-1.69,1.04-3.38,0.19-5.33C178.25,97.61,166.74,83.59,166.74,83.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 106.27,
    cy: 70.15,
    r: 15.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.7,63.16 97.39,63.16 106.42,71.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "110.08,69.93 116.46,75.57 116.46,63.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "102.82,69.92 96.36,63.7 96.36,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "109.27,70.69 106.4,73.38 103.62,70.69 96.9,76.29 115.61,76.29  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 106.27,
    cy: 103.99,
    r: 15.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.21,99.12c0.17,0.34,0.58,0.47,0.92,0.3c0.02-0.01,0.04-0.02,0.06-0.04c0.5-0.28,1.01-0.55,1.47-0.87 c0.17-0.16,0.3-0.34,0.4-0.55c-0.09-0.22-0.14-0.37-0.21-0.5c-0.2-0.37-0.41-0.74-0.62-1.1l-2.13-3.68 c-0.15-0.38-0.58-0.56-0.95-0.42c-0.07,0.03-0.13,0.06-0.19,0.11c-0.46,0.26-0.91,0.51-1.35,0.79c-0.34,0.16-0.48,0.56-0.32,0.9 c0.01,0.03,0.03,0.05,0.04,0.07C102.28,95.8,103.24,97.46,104.21,99.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.81,111.22c-0.93-1.62-1.87-3.23-2.8-4.85c-0.14-0.36-0.55-0.53-0.91-0.38c-0.05,0.02-0.1,0.05-0.15,0.08 c-0.47,0.26-0.93,0.53-1.39,0.81c-0.35,0.16-0.49,0.57-0.33,0.92c0.01,0.02,0.02,0.03,0.03,0.05l3.05,5.2 c0.23,0.2,0.55,0.22,0.81,0.06c0.49-0.27,0.99-0.54,1.47-0.85c0.17-0.15,0.32-0.33,0.43-0.53 C114.96,111.56,114.89,111.39,114.81,111.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.51,108.19c-0.61,0.22-1.28,0.16-1.84-0.16c-0.31-0.16-0.61-0.35-0.88-0.58 c-1.36-1.2-2.31-2.79-2.72-4.56c-0.27-1.1-0.34-2.21,0.5-3.09l-3.13-5.37c-0.25,0.16-0.49,0.31-0.71,0.47 c-0.92,0.57-1.45,1.61-1.37,2.7c0.06,1.09,0.22,2.18,0.47,3.24c1.04,3.68,2.89,7.09,5.41,9.96c0.94,1.14,2.06,2.13,3.31,2.91 c1.27,0.79,2.89,0.71,4.08-0.19L108.51,108.19z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 106.27,
    cy: 137.83,
    r: 15.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M103.99,140.73h-3.43v1.74c0,1.12,0.87,2.06,1.99,2.14L103.99,140.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.56,134.77h-1.47v3.03c0,1.63-1.32,2.94-2.94,2.94h-0.05l-5.25,3.87h5.7l-1.41,3.79l5.12-3.79h0.31 c1.18,0,2.15-0.96,2.15-2.14v-5.55C115.71,135.73,114.75,134.77,113.56,134.77C113.56,134.77,113.56,134.77,113.56,134.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.14,130.11H98.29c-1.18,0-2.14,0.96-2.14,2.14v5.55c0,1.18,0.96,2.15,2.14,2.15h6.84l-1.41,3.76 l5.13-3.77h0.31c1.19,0,2.15-0.96,2.15-2.15v-5.55C111.29,131.06,110.33,130.1,109.14,130.11z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.74,
    cy: 134.88,
    r: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.64,134.89c0,0.42-0.34,0.77-0.77,0.77c-0.42,0-0.77-0.34-0.77-0.77c0-0.42,0.34-0.77,0.77-0.77l0,0 C104.29,134.12,104.64,134.47,104.64,134.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.77,134.89c0,0.42-0.34,0.77-0.77,0.77c-0.42,0-0.77-0.34-0.77-0.77c0-0.42,0.34-0.77,0.77-0.77 c0,0,0,0,0,0C107.42,134.12,107.77,134.47,107.77,134.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.18,92.81l0.28-0.37l4.56-6.21c0,0,0.62-3.7,0.93-4.63c0.31-0.93,0.93-2.88,1.13-3.6 c0.21-0.72,0.41-1.54,0.82-1.24c0.41,0.31,0.41,1.54,0.21,2.16c-0.18,0.56-0.22,1.17-0.1,1.75c0.1,0.31,5.56-4.32,6.07-3.91 c0.51,0.41-0.2,2.37-1.23,3.7s-5.25,6.18-5.25,6.18s-4.84,12.97-6.28,15.03c-1.44,2.06-1.75,1.13-3.19,0 c-1.44-1.13-3.31-3.7-3.31-3.7L69.18,92.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.69,84.17c0,0,0.51-1.84,1.03-2.27c0.51-0.43,2.47-1.64,2.47-1.64l1.34-4.12c0,0,0.41-0.31,0.31,0.62 c-0.1,0.93-0.31,2.99-0.62,3.91c-0.31,0.92-1.65,2.57-1.65,2.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.77,77.07 69.69,92.61 63.62,98.78 61.87,92.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "62.9,96.35 63.62,98.78 69.69,92.61 68.6,90.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M42.77,179.4l-0.74,2.92c0,0-4.31,2.39-4.65,2.72c-0.33,0.33-0.2,1.73-0.2,1.73h12.35 c0.06-1.07-0.03-2.14-0.26-3.19c-0.19-1.29-0.3-2.6-0.34-3.9L42.77,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.19,186.76h12.35c0.01-0.27,0.01-0.53,0-0.8H37.17C37.16,186.39,37.19,186.76,37.19,186.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.66,184.92c0.85-0.72,1.88-1.18,2.99-1.33c1.99-0.33,3.79,0.4,4.18,0.79s0.66,1.53,0.66,1.53l-8.32,0.07 c-0.21-0.32-0.11-0.75,0.22-0.96C37.47,184.97,37.56,184.93,37.66,184.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.28,181.74c0,0.72-0.25,1.29-0.56,1.29s-0.57-0.58-0.57-1.29c0-0.72,0.25-1.29,0.57-1.29 S48.28,181.03,48.28,181.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73.6,179.4l0.74,2.92c0,0,4.31,2.39,4.65,2.72c0.33,0.33,0.2,1.73,0.2,1.73H66.83 c-0.07-1.07,0.02-2.14,0.26-3.19c0.18-1.29,0.3-2.6,0.34-3.9L73.6,179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.17,186.76H66.83c-0.02-0.27-0.03-0.53-0.02-0.8H79.2C79.21,186.22,79.2,186.49,79.17,186.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.71,184.92c-0.85-0.72-1.88-1.18-2.99-1.33c-1.99-0.33-3.79,0.4-4.18,0.79c-0.4,0.4-0.67,1.53-0.67,1.53 l8.32,0.07c0.21-0.32,0.11-0.75-0.22-0.96C78.9,184.97,78.81,184.93,78.71,184.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.09,181.74c0,0.72,0.25,1.29,0.57,1.29c0.31,0,0.56-0.58,0.56-1.29c0-0.72-0.25-1.29-0.56-1.29 C68.34,180.45,68.09,181.03,68.09,181.74z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "42.63,117.48 42.22,123.91 42.77,179.39 48.93,179.67 55.1,128.43 55.92,128.16 67.43,179.67  73.6,179.39 70.85,144.87 66.71,115.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "55.64,119.22 55.64,123.92 56.92,121.79 57.14,118.58  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.85,76.34c0,0-13.89,6.07-14.1,6.68c-0.21,0.61-3.91,15.95-3.31,17.39c0.76,1.67,2.69,2.47,4.41,1.84 c1.95-0.74,3.81-8.23,3.81-8.23s4.32,13.17,4.32,14.51c0,1.34,0.41,9.56,0.41,9.56s7.92,1.13,14.51-0.41s9.78-2.47,9.78-2.47 L63.6,96.38c0,0-1.65-18.63-1.84-19.35c-0.19-0.72-11.94-0.93-12.87-0.82S46.85,76.34,46.85,76.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M36.31,98.47c-0.47-1.52-1.32-2.9-2.45-4.01c-1.15-1.02-2.67-0.44-3.72,0.19c-0.55,2.86-0.91,5.26-0.68,5.79 c0.76,1.67,2.69,2.47,4.41,1.84C34.76,101.95,35.64,100.24,36.31,98.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.38,102.52l23.44-4.93l-0.19-1.16c0,0-0.04-0.37-0.09-1.03l-23.81,5 C39.94,101.09,40.16,101.78,40.38,102.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.71,115.25l-2.31-14.1l-23.01,4.78c0.28,0.86,0.49,1.75,0.62,2.65c0,1.34,0.41,9.56,0.41,9.56 s7.92,1.13,14.51-0.41C63.52,116.19,66.71,115.25,66.71,115.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.91,76.24c-0.93,0.1-2.06,0.1-2.06,0.1s-2.6,1.14-5.58,2.48L53.3,91.25c0,0,2.57-12.39,2.35-13.45 c-0.11-0.5-0.25-0.99-0.43-1.47C52.27,76.22,49.35,76.19,48.91,76.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.82,72.74c0,0,0.62,5.35,0.93,6.38c0.31,1.03-1.75,8.23-1.75,8.23s-5.97-6.07-6.69-7.82 s-2.37-7.82-2.37-7.82S48.19,74.39,52.82,72.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M42.94,71.71c0,0,0.37,1.39,0.85,3.02c0.25,0.14,0.55,0.3,0.92,0.48c1.92,1.02,4.1,1.41,6.25,1.14 c0.91-0.15,1.7-0.72,2.12-1.54c-0.15-1.15-0.25-2.07-0.25-2.07C48.19,74.39,42.94,71.71,42.94,71.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.17,59.24c0,0,1.56,3.12,2.6,4.48s2.71,4.38,1.98,6.15s-1.21,4.78-3.54,5.11 c-2.15,0.27-4.34-0.13-6.25-1.15c-1.88-0.94-2.08-1.25-2.08-1.25s-1.56,0-2.5-0.74c-0.94-0.74-2.81-3.02-2.29-5 c0.52-1.98,1.77-2.19,1.77-2.19s-2.6-1.04-0.94-3.65s5.21-3.54,6.88-3.54C47.47,57.46,50.17,59.24,50.17,59.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M49.65,62.67c0.24,0.38,0.56,0.7,0.94,0.94c0.74,0.52,1.77,0.21,1.47,1.15c-0.3,0.94-1.04,1.25-1.67,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M52.15,67.05c0,0-1.98,1.14-3.33,1.04c-0.71-0.02-1.39-0.23-1.98-0.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M47.78,68.09c0,0,0.74,2.6,1.77,1.77c0.65-0.57,1.1-1.35,1.25-2.21C49.84,68.02,48.81,68.17,47.78,68.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M47.67,63.58c0.23,0.37,0.24,0.77,0,0.91s-0.59-0.04-0.82-0.4c-0.23-0.36-0.24-0.77,0-0.91 S47.44,63.21,47.67,63.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M51,62c0.23,0.37,0.24,0.77,0,0.91c-0.24,0.14-0.59-0.04-0.82-0.4c-0.23-0.36-0.24-0.77,0-0.91 S50.77,61.64,51,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.49,63.26c0,0,0.3-1.39,1.39-1.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M49.06,61.09c0,0,0.61-1.15,1.57-0.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.17,62.47c0,0,6.77,0,7.29-1.15c0.52-1.15-1.04-1.98-1.04-1.98s5.83,0.21,6.46-1.56s-2.08-2.5-2.92-2.5 h-1.25c0,0-0.31-2.6-3.33-1.98c-3.02,0.63-8.85,4.58-9.56,6.88c-0.71,2.29-2.39,3.02-1.14,5.73c1.25,2.71,4.69,4.9,4.69,4.9 s-0.52-1.98,0.52-2.08s2.81,0.62,3.12,0.62s1.25-0.83,0.74-1.35s-1.04-0.83-1.14-1.14c-0.1-0.31,0.52-1.35,0.1-2.29 C42.28,63.61,40.17,62.47,40.17,62.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.85,67.86l2.41-1.6c0.39-0.26,0.92-0.15,1.18,0.24l4.76,7.16c0.26,0.39,0.15,0.92-0.24,1.18l-2.41,1.6 c-0.39,0.26-0.92,0.15-1.18-0.24l-4.76-7.16C37.36,68.64,37.46,68.12,37.85,67.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M38.92,74.97c0,0-0.48-1.23-0.96-2.13c-0.48-0.89-0.48-1.3-0.14-1.3c0.74,0.14,1.33,0.7,1.5,1.44 c0.16,0.74,0.21,1.51,0.14,2.27L38.92,74.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.04,79.71c0,0-3.91-3.91-4.05-4.25s0.02-4.78,0.06-6.06c0.02-0.18,0.15-0.33,0.33-0.37l0,0 c0.22-0.04,0.43,0.11,0.47,0.33c0,0.01,0,0.02,0,0.04l0.31,3.6l0.89-4.55c0.04-0.19,0.2-0.33,0.4-0.32l0,0 c0.22,0,0.4,0.18,0.4,0.41c0,0.01,0,0.01,0,0.02l-0.25,5.07l1.13-4.32c0.06-0.22,0.28-0.36,0.51-0.3c0,0,0.01,0,0.01,0l0,0 c0.18,0.05,0.31,0.22,0.31,0.41l-0.51,4.65L44,74.89v-1.65l1.15-1.93c0.09-0.15,0.27-0.2,0.42-0.13l0,0 c0.15,0.08,0.22,0.26,0.15,0.42l-0.77,1.71c0,0,1.51,6.17,1.58,6.38s-0.27,1.31-0.48,1.72s-9.4,19.9-9.93,20.65 c-0.53,0.75-4.25,1.92-5.89,0.14s-1.1-3.57-0.21-5.62S43.04,79.71,43.04,79.71z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 44.41,
    y1: 121.45,
    x2: 49.62,
    y2: 124.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 65.51,
    y1: 119.39,
    x2: 62.36,
    y2: 123.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 23.87,
    y1: 186.76,
    x2: 188.3,
    y2: 186.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.812f8969b024f16bf0a47d9bc73689d8.svg";
export { ForwardRef as ReactComponent };